export const SET_TEMPLATE = 'SET_TEMPLATE';
export const SET_COLOR = 'SET_COLOR';
